import { render, staticRenderFns } from "./ReviewApplyDia.vue?vue&type=template&id=502a76c0&scoped=true"
import script from "./ReviewApplyDia.vue?vue&type=script&lang=js"
export * from "./ReviewApplyDia.vue?vue&type=script&lang=js"
import style0 from "./ReviewApplyDia.vue?vue&type=style&index=0&id=502a76c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502a76c0",
  null
  
)

export default component.exports